import { InputAdornment, TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import styles from "./forgotpassword.module.css";
import Loader from "../../../admin/components/Loader";
import { ArrowLeft, Globe, Mail, Shield, Truck } from "react-feather";
import { useWebsite } from "../../../context/WebsiteContext";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const { websiteData, loading: wLoading } = useWebsite();

  const themePrimaryColor = websiteData && websiteData?.home_config && websiteData?.home_config?.primaryColor ? websiteData?.home_config?.primaryColor : "#ef233c";
  const themeSecondaryColor = websiteData && websiteData?.home_config && websiteData?.home_config?.secondaryColor ? websiteData?.home_config?.secondaryColor : "#0a2a52";

  const { register, handleSubmit, control, formState: { errors }, } = useForm({
    mode: "onChange",
  });

  async function onSubmit(data) {
    const postData = { ...data, utoken: websiteData ? websiteData?.utoken : '' };
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");
    return axios.post(process.env.REACT_APP_API_URL + "v1/forgot-password/email", postData).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        const resData = response.data;
        setSuccessMsg(resData.message);
        localStorage.setItem("passwordemail", resData?.data);
        setTimeout(() => {
          navigate("/forgot-password-code-check");
        }, 3000);
      }
      if (response.data.status === "ERROR") {
        setErrorMsg(response?.data?.message);
      }
    }).catch((error) => {
      if (error && error?.response && error?.response?.data && error?.response?.data?.message) {
        setErrorMsg(error?.response?.data?.message);
      }
      setLoading(false);
    });
  }

  return (<>
    {wLoading && <Loader />}
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={styles.MainDiv} style={{ "--primary-color": themePrimaryColor, "--secondary-color": themeSecondaryColor }}>
      <div className={styles.LoginFormSec}>
        <div className={styles.LoginCard}>
          <Link to={"/"} className={styles.BackHomeBU}>
            <ArrowLeft size={18} />
            Back to home
          </Link>

          <div className={styles.LogoSection}>
            <img src={websiteData && websiteData?.home_config && websiteData?.home_config?.logoURL ? websiteData?.home_config?.logoURL : "/images/logo.png"} alt={websiteData && websiteData?.home_config && websiteData?.home_config?.companyName ? websiteData?.home_config?.companyName : 'EF LOGISTICS'} className={styles.LogoImage} />
            <h1 className={styles.LogoText}>{websiteData && websiteData?.home_config && websiteData?.home_config?.companyName ? websiteData?.home_config?.companyName : 'EF LOGISTICS'}</h1>
            <p className={styles.LogoSubText}>{websiteData && websiteData?.home_config && websiteData?.home_config?.heroTitle ? websiteData?.home_config?.heroTitle : 'Seamless Logistics from Pick-Up to Delivery'}</p>
          </div>

          <h2 className={styles.Title}>Forgot Password</h2>
          <p className={styles.SubTitle}>Reset Your Password</p>

          <form onSubmit={handleSubmit(onSubmit)}>
            {successMsg && (<p className={styles.SuccessM} style={{ margin: '15px 0', fontWeight: 'bold' }}>{successMsg}</p>)}
            {errorMsg && (<p className={styles.ErrorM} style={{ margin: '15px 0', fontWeight: 'bold' }}>{errorMsg}</p>)}

            <div className={styles.FormGroup}>
              <Controller
                control={control}
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  }
                })}
                render={({ field }) => (<TextField
                  {...field}
                  classes={{ root: styles.inputRoot }}
                  fullWidth
                  label="Email Address"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (<InputAdornment position="start">
                      <Mail size={18} />
                    </InputAdornment>)
                  }}
                />)}
              />
              {errors.email && (<span className={styles.ErrorM}>{errors.email.message}</span>)}
            </div>

            <div className={styles.ForgotPasswordRow}>
              <Link to={"/sign-in"} className={styles.ForhotPassText}>Login</Link>
            </div>

            <button type="submit" className={styles.LoginBU}>Forgot Password</button>
          </form>

        </div>
      </div>

      <div className={styles.LoginBGSec}>
        <img src="/images/login-side-banner.png" alt="Logistics" className={styles.BGImage} />
        <div className={styles.Overlay}></div>

        <div className={styles.FeatureWrap}>
          <div className={styles.FeatureItem}>
            <Shield size={30} />
            <h4>Secure & Reliable</h4>
            <p>Advanced shipment protection and real-time tracking for complete peace of mind.</p>
          </div>

          <div className={styles.FeatureItem}>
            <Truck size={30} />
            <h4>Fast Transportation</h4>
            <p>Efficient road, air, and sea freight solutions with on-time delivery assurance.</p>
          </div>

          <div className={styles.FeatureItem}>
            <Globe size={30} />
            <h4>Worldwide Logistics</h4>
            <p>Connecting businesses globally with seamless supply chain and cargo management.</p>
          </div>
        </div>
      </div>
    </div>
  </>);
};

export default ForgotPassword;